// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1hz8W","paramInput":"JobSimulator_paramInput__3jjZR","input":"JobSimulator_input__1dgVs"};